// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"28398":"b6323009d4472833","48846":"6438dbb375600f1b"}[chunkId] + ".css";
};